import { useState, useEffect } from 'react'
import { on } from '../util/EventManager'

function LoadingScreen() {

  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    on('hideLoadingScreen', () => {
      setIsLoading(false)
    })
  }, [])

  return (
    <>
      {isLoading && <div id="loadingscreen" className="loadingscreen">
        <div className="loaderbox">
          <h1>Der Dummy-Showroom.</h1>
          <h2>GM-W</h2>
          <div className="loader"></div>
          <p>Gleich gehts los! Bitte warten...</p>
        </div>
      </div>}
    </>
  )
}

export default LoadingScreen